import { BodyNoPower } from "./BodyNoPower";
export default BodyNoPower;
